<app-modal
  [isActive]="(action && !action?.isAllowed) || showAlert"
  (modalState)="closeModal.emit(true)"
>
  <p class="modal-card-title" modal-title>
    {{ 'itinerary-actions.not-available' | translate }}
  </p>
  <div class="has-text-grey" modal-content *ngIf="action?.messages">
    <div *ngFor="let message of action?.messages">
      <p>
        {{ 'errors.' + message.messageCode | dictionary : message.values | async }}
      </p>
    </div>
  </div>
  <div class="has-text-grey" modal-content *ngIf="showAlert">
    <div>
      <p>
        {{ 'errors.infants-or-childer-without-adult' | translate }}
      </p>
    </div>
  </div>
</app-modal>
